<template>
  <div id="profileGallery">
    <mu-card>
      <mu-card-header titleClass="largeTitle blueTitle" :title="$t('message.labelGallery')"></mu-card-header>
      <mu-card-text>
        <div id="uploadImage" v-if="isOwner">
          <mu-raised-button id="uploadBtn" :label="$t('message.labelUploadPhoto')" @click="bindUploadEvent" :disabled="isUploadingImage" />
          <input type="file" @change="chooseImage" accept="image/*">
        </div>
        <mu-linear-progress v-if="isUploadingImage" class="uploadProgress" mode="determinate" :size="10" :value="uploadProgress "/>
        <div id="galleryScroller">
          <mu-grid-list :cell-height="250" :padding="0" class="scroller">
            <mu-grid-tile :class="{'isOwner': isOwner}" class="item" v-for="image, index in images" :key="'image-' + index">
              <img class="img" :src="image.image_url"/>
              <mu-icon-button v-if="isOwner" slot="action" icon="photo" @click.native="setAsProfile(image)" tooltip="Set as profile picture" tooltipPosition="bottom-center"></mu-icon-button>
              <mu-icon-button v-if="isOwner" slot="action" icon="delete" @click.native="deleteImage(index, image.image_id)"></mu-icon-button>
            </mu-grid-tile>
          </mu-grid-list>
        </div>
        <avatar-uploader v-if="profileImage" :hideAvatar="true" :imageUrl="profileImage" @destroyUploader="profileImage= $event" />
      </mu-card-text>
    </mu-card>
  </div>
</template>
<script>
  import axios from 'axios';
  import './Gallery.less';
  import ProfileApi from '../../../api/Profile/'
  import AvatarUploader from "../../UploadAvatar/UploadAvatar";
  import ImageManager from '../../../helpers/ImageManager';

  export default {
    components: {AvatarUploader},
    name: 'profile-gallery',
    props: {
      isOwner: {
        type: Boolean,
        required: true,
      },
      images: {
        type: Array,
        required: true,
      }
    },
    data () {
      return {
        uploadProgress: 0,
        profileImage: null,
      }
    },
    methods: {
      deleteImage (index, imageId) {
        let self = this;
        self.$alert({
          title: "Are you sure?",
          text: "Are you sure you want to remove the following picture?",
          type: "warning",
          showCancelButton: true,
          showLoaderOnConfirm: false,
          confirmButtonColor: "white",
          cancelButtonColor: "white",
        })
        .then(function (response) {
          ProfileApi.deleteImage(imageId).then((response) => {
            if (response.data.complete) {
              self.$toastr.success('Image deleted');
              self.images.splice(index, 1);
            }
          });
        }.bind(self))
        .catch(self.$alert.noop);
      },
      bindUploadEvent() {
        $('#uploadBtn').next().trigger('click');
      },
      chooseImage(event) {
        let self = this,
          input = event.target;
        // check if has images
        if (input.files && input.files[0]) {
          // save first image, as its not mulitple
          self.uploadImage(input.files[0]);
        }
      },
      setAsProfile(image) {
        let self = this;
        // clear image to reinitialize upload avatar component
        self.profileImage = null;
        setTimeout(() => {
          self.profileImage = image.image_url;
        }, 500)
      },
      uploadImage(file) {
        let self = this,
          data = new FormData();
        data.append('file', file);
        let config = {
          onUploadProgress: function(progressEvent) {
            self.uploadProgress = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
          }
        };
        axios.post(ProfileApi.galleryUploadURL(), data, config).then((response) => {
          if(response.data.complete === true) {
            self.images.unshift(response.data.image);
            self.$toastr.success(self.$t('message.labelSuccess'));
            self.uploadProgress = 0;
          }
        }).catch((error) => {
          if(error.data.response) {
            self.$toastr.error(error.data.response.message);
            self.uploadProgress = 0;
          }
        });
      }
    },
    computed: {
      isUploadingImage() {
       let self = this;
       return self.uploadProgress !== 0 ? true : false;
      }
    },
    mounted () {
      let self = this;
      self.scroller = $('.scroller');
    }
  }

</script>

<style lang="less">
  @import "./Gallery.less";
</style>



// WEBPACK FOOTER //
// Gallery.vue?3ef3a428